// extracted by mini-css-extract-plugin
export default {"form":"AddPost_form__94PoL","button":"AddPost_button__kaNh2"};